import React, { useState, useEffect, useRef } from 'react';
import { shallowEqual, useSelector, useDispatch } from 'react-redux';
import './Module1Practice.scss';
import { getVideo, GetUserVideo } from '../../s3Func/s3Download';
import { API } from 'aws-amplify';

import Button from 'react-bootstrap/Button';
import awesomeJobSound from './assets/awesome_job.mp3';
import tryAgainSound from './assets/try_again.mp3';
import { CloudfrontVideoFormat } from '../../videos/CloudfrontVideoFormat';
import MediaService from '../../services/MediaService';
import { sleep } from '../../utils';

/**
 *  Creates and runs the practice section for Unit1 Module1
 *  Note: This code is reused in other modules as well
 * @param {*} props
 * @returns the HTML code for the practice section.
 */
const EyeContactPractice = ({
  module,
  stepComplete,
  background,
  setDisplayPractice,
  world2,
  unit4,
  next,
}) => {
  // Generate a random number based on the arraySize passed in.
  function getRandomInt(arraySize) {
    return Math.floor(Math.random() * Math.floor(arraySize));
  }

  // Initialize variables to be used later
  const { login } = useSelector((state) => state.loginReducer, shallowEqual);
  const practiceImages = [
    'appfiles/eye_contact/not_looking_example.jpg',
    'appfiles/eye_contact/not_looking_example_2.jpg',
    'appfiles/eye_contact/not_looking_example_3.jpg',
    'appfiles/eye_contact/not_looking_example_4.jpg',
    'appfiles/eye_contact/not_looking_example_5.jpg',
    'appfiles/eye_contact/not_looking_example_6.jpg',
    'appfiles/eye_contact/not_looking_example_7.jpg',
    'appfiles/eye_contact/not_looking_example_8.jpg',
    'appfiles/eye_contact/looking_example.jpg',
    'appfiles/eye_contact/looking_example_2.jpg',
    'appfiles/eye_contact/looking_example_3.jpg',
    'appfiles/eye_contact/looking_example_4.jpg',
    'appfiles/eye_contact/looking_example_5.jpg',
    'appfiles/eye_contact/looking_example_6.jpg',
    'appfiles/eye_contact/looking_example_7.jpg',
    'appfiles/eye_contact/looking_example_8.jpg',
  ];
  const [practiceVideo, setPracticeVideo] = useState(false);
  const [showPractice, setShowPractice] = useState(false);
  const [practiceImage, setPracticeImage] = useState(
    practiceImages[getRandomInt(practiceImages.length)]
  );
  const [practiceCount, setPracticeCount] = useState(0);
  const [displayPracticeVideo, setDisplayPracticeVideo] = useState();
  const [askQuestion, setAskQuestion] = useState(false);
  const [displayAwesomeJob, setDisplayAwesomeJob] = useState(false);
  const [displayTryAgain, setDisplayTryAgain] = useState(false);
  const [score, setScore] = useState(0);
  const [firstTime, setFirstTime] = useState(true);
  const [questionSound, setQuestionSound] = useState('');

  const yesBtn = useRef();
  const noBtn = useRef();
  const dispatch = useDispatch();

  const ExitImage = MediaService.getImage('/Images/close.png', login);

  const saveToDB = async () => {
    const today = new Date();
    const payload = {
      body: {
        student_id: login.studentid,
        metric: 'practice_eye_contact',
        result: JSON.stringify({
          day: module.currentday,
          created: today.toISOString(),
          review: world2 ? 1 : 0,
          values: [{ value: score, target: 3 }],
        }),
      },
    };
    try {
      await API.post('TIR', '/v3/student/result', payload);
    } catch (error) {
      console.log(error);
    }
  };

  const start = async () =>{
    if (!unit4) {
      if (world2) {
        switch (module.currentday) {
          case 1:
            setDisplayPracticeVideo('38dcf20e502f1be8274d302f4182/480.m3u8');
            break;
          case 2:
            setDisplayPracticeVideo('04159ac7ba0fd174b2754614cab9/480.m3u8');
            break;
          case 3:
            setDisplayPracticeVideo('319a8c4a075035c36748bdd3d387/480.m3u8');
            break;
          default:
            break;
        }
        setQuestionSound(getVideo('appfiles/eye_contact/review_making_eye_contact.mp3', login));
      } else {
        switch (module.currentday) {
          case 1:
            setDisplayPracticeVideo('5afeb5bdee313e5c939bdecad433/480.m3u8');
            break;
          case 2:
            setDisplayPracticeVideo('fbf53d23d7ac4a22e20a6ee333ea/480.m3u8');
            break;
          case 3:
            setDisplayPracticeVideo('150f7990b281dbe8ad1c82a612c9/480.m3u8');
            break;
          default:
            await GetUserVideo(`influencers/${login.influencerid}/eye_contact_video_message.mp4`).then(
              (data) => {
                setDisplayPracticeVideo(data);
              }
            );
        }
        setQuestionSound(getVideo('appfiles/eye_contact/making_eye_contact.mp3', login));
      }
      setPracticeVideo(true);
    }
    else{
      setQuestionSound(getVideo('appfiles/eye_contact/making_eye_contact.mp3', login));
      introVideoEndHandler()
    }
  }

  // Decide which video to play for practice based on the day
  useEffect(() => {
    start();
  },[]);

  const getRandomImage = async () => {
    const randomImage = practiceImages[getRandomInt(practiceImages.length)];
    const practiceImageUrl = getVideo(randomImage, login);
    setPracticeImage(practiceImageUrl);
  };

  const introVideoEndHandler = async () => {
    setPracticeVideo(false);
    await getRandomImage();
    setShowPractice(true);

    if (practiceCount <= 3) setAskQuestion(true);
  };

  const onAskingQuestionHandler = () => {
    yesBtn.current.disabled = true;
    noBtn.current.disabled = true;
  };

  const onQuestionEndHandler = () => {
    yesBtn.current.disabled = false;
    noBtn.current.disabled = false;
    setAskQuestion(false);
  };

  const handleCorrectAnswer = () => {
    if (firstTime) setScore(score + 1);
    setPracticeCount(practiceCount + 1);
    setDisplayAwesomeJob(true);
  };

  const handleWrongAnswer = () => {
    setDisplayTryAgain(true);
    setFirstTime(false);
    onAskingQuestionHandler();
    sleep(750).then(() => {
      onQuestionEndHandler();
    });
  };

  // This code decides whether the user selected the correct image out of the available options.
  const onPhotoGuess = async (practiceImage, response) => {
    yesBtn.current.disabled = true;
    noBtn.current.disabled = true;
    let correct = false;

    const isLooking = practiceImage.includes('/looking_example');
    const isNotLooking = practiceImage.includes('/not_looking_example');

    if (
      (isLooking && response === 'yes') ||
      (isNotLooking && response === 'no')
    ) {
      handleCorrectAnswer();
      correct = true;
    } else {
      handleWrongAnswer();
    }

    if (correct && practiceCount < 2) {
      await sleep(2000);
      await getRandomImage();
      setQuestionSound(getVideo('appfiles/eye_contact/making_eye_contact.mp3', login));
      setAskQuestion(true);
      setFirstTime(true);
    }
  };

  // The HTML code for the practice section.
  return (
    <>
      {practiceVideo && (
        <CloudfrontVideoFormat
          source={displayPracticeVideo}
          back='/unit1'
          background={background}
          close={setDisplayPractice}
          ended={() => introVideoEndHandler()}
        />
      )}
      {showPractice && (
        <div
          className='practice-section'
          style={{ backgroundImage: `url(${background})` }}
        >
          <button className='practice-section-back-btn'>
            <img
              alt=''
              loading='eager'
              src={ExitImage}
              onClick={() => setDisplayPractice(false)}
            />
          </button>

          <section className='practice-section-content'>
            <header>
              <h2>Are these people making eye contact?</h2>
            </header>
            <main>
              <figure>
                <img src={practiceImage} alt='' />
              </figure>
            </main>
            <div className='practice-section-btns'>
              <Button
                ref={yesBtn}
                variant='success'
                onClick={() => onPhotoGuess(practiceImage, 'yes')}
              >
                Yes
              </Button>
              <Button
                ref={noBtn}
                variant='danger'
                onClick={() => onPhotoGuess(practiceImage, 'no')}
              >
                No
              </Button>
            </div>
          </section>
        </div>
      )}
      {!displayAwesomeJob && !displayTryAgain && askQuestion && (
        <audio
          autoPlay
          onPlay={onAskingQuestionHandler}
          onEnded={onQuestionEndHandler}
        >
          <source src={questionSound}></source>
        </audio>
      )}
      {displayAwesomeJob && (
        <audio
          autoPlay
          onEnded={() => {
            setDisplayAwesomeJob(false);
            if (practiceCount >= 3) {
              // If is not reviewing the module, save to db
              if (unit4) {
                next()
              }
              else {
                if (!module.reviewIcon) {
                  dispatch({ type: stepComplete, payload: 'practice' });
                }
              }
              module.sectionCompleted = module.sectionCompleted + 1
              saveToDB();
              setDisplayPractice(false);
            }
          }}
        >
          <source src={awesomeJobSound}></source>
        </audio>
      )}
      {displayTryAgain && (
        <audio autoPlay onEnded={() => setDisplayTryAgain(false)}>
          <source src={tryAgainSound}></source>
        </audio>
      )}
    </>
  );
};
export default EyeContactPractice;
